import { Outlet, Link, useLocation } from "react-router-dom";
import styles from "./Layout.module.css";
import { DefaultButton, IButtonStyles, ICommandBarStyles, Label, Stack, MessageBar, MessageBarType } from "@fluentui/react";
import { useEffect, useState } from "react";
import { SuMenuItem, SuAPIError } from "../../api/superuser/models_superuser";
import { getSuperuserMenuList } from "../../api/superuser/api_superuser";

interface MenuItemButtonProps {
    text: string;
    to: string;
}

const MenuItemButton = (props: MenuItemButtonProps) => {
    const { text, to } = props;
    const location = useLocation();
    const isActive = location.pathname.startsWith(to);
    
    return (
        <Link 
            to={to} 
            style={{
                display: 'block',
                textDecoration: 'none',
                color: 'inherit'

            }}
        >
            <div 
                style={{
                    padding: '3px 3px',
                    cursor: 'pointer',
                    backgroundColor: isActive ? '#E6E6E6' : 'transparent',
                }}
                onMouseEnter={(e) => {
                    if (!isActive) {
                        e.currentTarget.style.backgroundColor = '#E6E6E6';
                    }
                }}
                onMouseLeave={(e) => {
                    if (!isActive) {
                        e.currentTarget.style.backgroundColor = 'transparent';
                    }
                }}
            >
                {text}
            </div>
        </Link>
    );
};

const LayoutSuperuser = () => {
    const [menulist, setMenulist] = useState<SuMenuItem[]>([]);
    const [error, setError] = useState<string | null>(null);

    // APIErrorをチェックしてダイアログで表示
    const isAPIError = (response: any): response is SuAPIError => {
        return response && typeof response === 'object' && 'error' in response;
    };

    const showErrorDialog = (message: string) => {
        setError(message);
    };

    useEffect(() => {
      const fetchMenu = async () => {
          const menues = await getSuperuserMenuList();
          if (isAPIError(menues)) {
              showErrorDialog(menues.error);
          } else {
              setMenulist(menues ?? []);
          }
      };
      fetchMenu()
    }, []);

    return (
        <div className={styles.layout}>
            <header className={styles.header} role={"banner"} style={{paddingLeft: "20px"}}>
                <Stack horizontal verticalAlign="center" tokens={{childrenGap: "16px"}}>
                    <div className={styles.headerTitleContainer}>
                        <h1 className={styles.headerTitle}>WorQu for GAI</h1>
                    </div>
                </Stack>
            </header>
            <Stack horizontal styles={{ root: { flex: 1, overflow: 'hidden' } }}>
                <div style={{
                    flex: "1",
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    background: "radial-gradient(108.78% 108.78% at 50.02% 19.78%, #FFFFFF 57.29%, #EEF6FE 100%)",
                    boxShadow: "0 2px 4px #00000024, 0 0 2px #0000001f",
                    borderRadius: "8px",
                    marginLeft: "20px",
                    marginRight: "20px",
                    marginBottom: "45px",
                    overflow: "auto",
                    padding: "30px 60px"
                }}>
                    <Outlet />
                </div>
                <Stack style={{
                    width: "294px", 
                    paddingLeft: "10px",
                    paddingTop: "10px",
                    marginRight: "10px"
                }}>
                    <Label style={{fontWeight: 600, fontSize: "20px", color: "#58535E", marginBottom: "10px"}}>DSK管理者メニュー</Label>
                    <Stack style={{listStyleType: 'none', padding: 0, margin: 0}}>
                        {
                            menulist.map((v, idx) => (<MenuItemButton key={idx} text={v.function_name} to={`/superuser/${v.route_name}`}/>))
                        }
                    </Stack>
                    {error && (
                        <MessageBar messageBarType={MessageBarType.error}>
                            {error}
                        </MessageBar>
                    )}
                </Stack>
            </Stack>
        </div>
    );
};

export default LayoutSuperuser;